// extracted by mini-css-extract-plugin
export default {"dummy":"ContextMenu_dummy__DL6yc"};